import { render, staticRenderFns } from "./ProspectAvatar.vue?vue&type=template&id=47d58640&scoped=true"
import script from "./ProspectAvatar.vue?vue&type=script&lang=js"
export * from "./ProspectAvatar.vue?vue&type=script&lang=js"
import style0 from "./ProspectAvatar.vue?vue&type=style&index=0&id=47d58640&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d58640",
  null
  
)

export default component.exports